/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export type StateCode = (typeof StateCode)[keyof typeof StateCode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StateCode = {
  Active: 'Active',
  Inactive: 'Inactive'
} as const;
